import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getClientKeyWithAccessToken } from '../lib/security'

const baseUrl = process.env.REACT_APP_BASEURLRV

export const guenoApiRv = createApi({
  reducerPath: 'guenoApiRv',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: async (headers, { getState }) => {
      const { accessToken } = getState().login
      const clientKey = await getClientKeyWithAccessToken(accessToken)
      headers.set('Authorization', `Bearer ${accessToken}`)
      headers.set('client-key', clientKey)
      return headers
    },
  }),
  endpoints: (builder) => ({
    processTransactions: builder.mutation({
      query: ({ itemId }) => {
        const date = new Date().getTime()
        return {
          url: `/kyt/transactions/all/verify`,
          method: 'POST',
          params: {
            itemId,
            fromDate: date,
            toDate: date,
          },
          body: {},
        }
      },
    }),
  }),
})

export const { useProcessTransactionsMutation } = guenoApiRv
